import { render, staticRenderFns } from "./UserMessages.vue?vue&type=template&id=501953f1&"
import script from "./UserMessages.vue?vue&type=script&lang=js&"
export * from "./UserMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('501953f1')) {
      api.createRecord('501953f1', component.options)
    } else {
      api.reload('501953f1', component.options)
    }
    module.hot.accept("./UserMessages.vue?vue&type=template&id=501953f1&", function () {
      api.rerender('501953f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserMessages.vue"
export default component.exports